<!--
 * @Author: Merlin
 * @Date: 2024-06-07 15:55:03
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-05 10:24:26
 * @Description: <CasinoHistoryModalWavesDetail 组件名 
-->
<template>
    <ModalTitle
        footer-class=""
        :model-value="modelValue"
        container-class="!w-[530px] max-w-[96vw]"
        @update:model-value="handleUpdateModelValue"
        @hideModel="emits('hideModel')"
        :bodyStyle="{
            'overflow-y': 'auto',
            'maxHeight': `calc(100vh - 80px - 50px - ${footerShowing ? '88px' : '0px'})`, 
        }"
    >
        <template #header>
            <span class="text-[24px] leading-10">
                📄 {{ sTitleI18nKey && $t(sTitleI18nKey) }}
            </span>
        </template>
        <!-- ↑ 标题栏 --> 
        <!-- ↓ 正文 --> 
        <div>
            <section class="body__header">
                <div class="left">
                    <CurrentCoin
                        class="total-icon"
                        size="48px" 
                        :name="history.pairCurrency"
                    ></CurrentCoin>
                    <!-- ↑币种图标，↓涨跌箭头 --> 
                    <span class="icon"> 
                        <IconSvgUse
                            size="38px"  
                            :use="history.oTypeColor?.icon02"
                            :style="{color: history.oTypeColor?.color }"
                        />
                    </span>
                </div>
                <!-- 
                    ↑ 币种图标
                    ◆ 左右分界 ========================================================== 
                    ↓ 右侧信息
                -->
                <div class="right">
                    <div class="row">
                        <div class="row__title">
                            {{ $t('waves.Player')}}:
                        </div>
                        <div class="row__date">
                            <div class="user">
                                <div class="user user--clickable flex flex-nowrap items-center gap-1"> 
                                    <div class="user__avatar" style="width: 22px; height: 22px;">
                                        <div class="user__inner">
                                            <UserAvatar
                                                class="avatar"
                                                size='22px'
                                            ></UserAvatar>
                                        </div>
                                    </div>
                                    <div class="user__wrap">
                                        <span class="user__name"> 
                                            {{ history.name }} 
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row"> 
                        <div class="row__title">
                            {{ $t('waves.OpenDate')}}:
                        </div>
                        <div class="row__date">
                            <span class="datetime">
                                <!-- {{ '06/13/2024, 03:24 AM' }} -->
                                {{ moment(history.timestamp).format(sDateFormet) }}
                            </span>
                        </div>
                    </div>
                    <!--
                        ↑ 🅰️ 以上是固定内容：玩家名，建仓时间， 
                        ↓ ❤️ 在已平仓的窗口专用
                    -->
                    <div class="row"
                        v-if="history.closedAt > 0"
                    >
                        <div class="row__title">
                            {{ $t('waves.CloseDate')}}:
                        </div>
                        <div class="row__date">
                            <span class="datetime">
                                <!-- {{ '06/13/2024, 03:47 AM' }} -->
                                {{ moment(history.closedAt).format(sDateFormet) }}
                            </span>
                        </div>
                    </div>
                    <!-- 
                        ↓ ❤️ 在 CorgiWaves 以外的真实币种中使用 
                        ↓ 注意 CorgiWaves 没有手续费，甚至下注时都不显示下方手续费类型的选项 
                    -->
                    <template v-if="!isSpecialPair" >
                        <div class="row">
                            <div class="row__title">
                                {{ $t('waves.FeeType')}}: 
                            </div>
                            <div class="row__date">
                                <span>
                                    {{
                                        $t(
                                            history.feeType === oPnlFlat.pnl
                                            ? 'waves.PnLFee'
                                            : 'waves.FlatFee'
                                        ) + sFeeAmount
                                    }}
                                </span>
                            </div>
                        </div>
                        <!-- ↓ ❤️ 在排名表格中专用  -->
                        <div class="row"
                            v-if="history.place > 0"
                        >
                            <div class="row__title">
                                {{ $t('waves.Place') }}:
                            </div>
                            <div class="row__date">
                                <span class="white">
                                    {{ history.place }}
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
            </section>
            <!--
                ↑ 头部
                | 上下在此分界 ================================================================ 
                ↓ 其它
            -->
            <div class="body__main">
                <div class="details">
                    <section class="detail">
                        <em class="detail__title">
                            {{ $t('waves.calc_WagerAmount') }}
                        </em>
                        <div class="detail__value">
                            <div class="detail-value flex flex-nowrap items-center gap-1">
                                <CurrentCoin
                                    size="18px"
                                    :name="history.currency"
                                />
                                <WavesValue
                                    :number-value="history.wager" 
                                    :coin-name="history.currency"
                                    :iTailLong="history.iDecimalPlaces" 
                                    :usePopper="true" 
                                ></WavesValue>
                            </div>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                    <section class="detail">
                        <em class="detail__title">
                            {{ $t('waves.Multiplier') }}
                        </em>
                        <div class="detail__value">
                            <div class="detail-value value-box">
                                <span>x</span>
                                <span class="currency">
                                    {{ number2LocaleString(history.multi) }}
                                </span>
                            </div>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                    <section class="detail">
                        <em class="detail__title">
                            P&L<!-- 中英一体 -->
                        </em>
                        <div class="detail__value" 
                            :style="{color: oColors.pnl}" 
                        >
                            <div class="detail-value flex flex-nowrap items-center gap-1" >
                                <CurrentCoin
                                    v-if="oFinalPnlAndRoi.pnl"
                                    size="18px"
                                    :name="history.currency"
                                />
                                <WavesValue
                                    :number-value="oFinalPnlAndRoi.pnl || null"
                                    :coin-name="history.currency"
                                    :iTailLong="history.iDecimalPlaces" 
                                    :usePopper="true" 
                                ></WavesValue>
                            </div>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                    <section class="detail">
                        <em class="detail__title">
                            {{ $t('waves.EntryPrice') }} 
                        </em>
                        <div class="detail__value">
                            <WavesValue
                                preffix="$"
                                :coin-name="sUSDT"
                                :number-value="history.entryPrice"
                                :iTailLong="history.precision"
                                :usePopper="true" 
                            ></WavesValue>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                    <section class="detail">
                        <em class="detail__title">
                            {{ $t('waves.BustPrice') }}
                        </em>
                        <div class="detail__value">
                            <WavesValue
                                preffix="$"
                                :coin-name="sUSDT"
                                :number-value="history.bustPrice"
                                :iTailLong="history.precision"
                                :usePopper="true" 
                            ></WavesValue>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                    <section class="detail">
                        <em class="detail__title">
                            {{ $t('waves.ExitPrice') }}
                        </em>
                        <div class="detail__value">
                            <WavesValue
                                preffix="$" 
                                :coin-name="sUSDT"
                                :number-value="history.exitPrice || null"
                                :iTailLong="history.precision"
                                :usePopper="true" 
                            ></WavesValue>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                    <section class="detail">
                        <em class="detail__title">
                            {{ $t('waves.TakePrice') }}
                        </em>
                        <div class="detail__value" :style="oTriggerColor.profitPrice">
                            <WavesValue
                                preffix="$"
                                :coin-name="sUSDT"
                                :number-value="history.takeProfitPrice || null"
                                :iTailLong="history.precision"
                                :usePopper="true" 
                            ></WavesValue>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                    <section class="detail">
                        <em class="detail__title">
                            {{ $t('waves.TakeProfit') }}
                        </em>
                        <div class="detail__value" :style="oTriggerColor.profitValue">
                            <WavesValue
                                :coin-name="history.currency"
                                :number-value="history.takeProfitAmount || null" 
                                :iTailLong="history.iDecimalPlaces"
                                :usePopper="true" 
                            ></WavesValue>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                    <section class="detail">
                        <em class="detail__title">
                            ROI <!-- 中英一体 -->
                        </em>
                        <div class="detail__value">
                            <div class="detail-value detail-value--win px-[3px]"
                                :style="{color: oColors.roi}" 
                            >
                                {{ (oFinalPnlAndRoi.roi || 0).toFixed(2) }}%
                            </div>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                    <section class="detail">
                        <em class="detail__title">
                            {{ $t('waves.StopPrice' )}}
                        </em>
                        <div class="detail__value" :style="oTriggerColor.lossPrice">
                            <WavesValue
                                preffix="$"
                                :number-value="history.stopLossPrice || null" 
                                :iTailLong="history.precision"
                                :coin-name="sUSDT"
                                :usePopper="true" 
                            ></WavesValue>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                    <section class="detail">
                        <em class="detail__title">
                            {{ $t('waves.StopLoss') }}
                        </em>
                        <div class="detail__value" :style="oTriggerColor.lossValue"> 
                            <WavesValue
                                :number-value="history.stopLossAmount || null" 
                                :coin-name="history.currency"
                                :iTailLong="history.iDecimalPlaces"
                                :usePopper="true" 
                            ></WavesValue>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ --> 
                    <section class="detail">
                        <em class="detail__title">
                            {{ $t('waves.FundingH') }}
                        </em>
                        <div class="detail__value"
                            :style="{ color: oColors.funding }" 
                        >
                            <!-- 此处值可为负 -->
                            <WavesValue
                                :number-value="history.funding || null"
                                :coin-name="history.currency"
                                :usePopper="true" 
                            ></WavesValue>
                        </div>
                    </section>
                    <!--
                        ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
                        ↓ 最后2项
                        ↓ 最后2项
                        ↓ 最后2项
                    -->
                    <section class="detail bet-currency">
                        <em class="detail__title">
                            {{ $t('waves.BetCurrency') }}
                        </em>
                        <div class="detail__value">
                            <div class="detail-value flex flex-nowrap items-center gap-1">
                                <CurrentCoin
                                    size="18px"
                                    :name="history.currency"
                                />
                                <span>
                                    {{ (history.currency || '').toUpperCase() }}
                                </span>
                            </div>
                        </div>
                    </section>
                    <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                    <section class="detail">
                        <em class="detail__title">
                            {{ $t('waves.Status') }}
                        </em>
                        <div class="detail__value">
                            <ContractState 
                                :state="oActiveContractInfo?.stateRealtime || history.state" 
                            ></ContractState>
                        </div>
                    </section>
                </div>
            </div>
        </div>
        <!-- 
            ↑ 上方信息区
            ↓ 下方按钮区，按需显示， 
        -->
        <template
            v-slot:footer
            v-if="footerShowing"
        >
            <div class="w-full">
                <ButtonThe3DButton
                    color="red"
                    class="w-full h-14"
                    v-click-and-rest 
                    :disabled="disabledCashoutButton"
                    :dismark="disabledCashoutButton"
                    @click="fnCashOut(history) as any" 
                >
                    <div class="text-white items-center text-[16px]">
                        {{ $t('waves.CashOut') }}
                    </div>
                </ButtonThe3DButton>
            </div>
        </template>
    </ModalTitle>
</template>


<script lang="ts" >
export default defineComponent({name: 'WavesDetail'});
</script>

<script lang="ts" setup>
import WavesValue from '@/pages/casino/futuresGame/_components/wavesValue.vue'; 
import ContractState from "@/pages/casino/futuresGame/_components/contractState.vue";
// --- ↑以上是一些 vue 组件 ---------------------------------------- 
import moment from 'moment';
import { HistoryTabsEnum } from '@/components/Casino/History/Tabs/ts/Tabs';
import {
    aCoinList,
    oTable4Types,
    oColorInfo,
    oPnlFlat,
    oWavesContractStatus,
    WavesContractStateAll,
    oSpecialCoin, 
} from '@/pages/casino/futuresGame/ts/wavesData'; 
import {
    getActiveContractInfo,
} from '@/pages/casino/futuresGame/ts/wavesFn'; 
import type {
    WavesHistoryPlus,
} from '@/socket/game/dto/waves.dto';

const props = defineProps({
    modelValue: { // 控制可见性 
        type: Boolean, 
    },
    history: { // 数据 
        type: Object as PropType<WavesHistoryPlus>, 
        required: true,
        default: () => ({}),
    },
    fnCashOut: {
        type: Function, 
    },
});

const route = useRoute();
const {locale} = useI18n();
const emits = defineEmits(['update:modelValue','hideModel']); 
const sUSDT = 'usdt'; 
const oDialogTitles = {
    [HistoryTabsEnum.active]: 'waves.ActiveBet', // i18n 的键名 
    [HistoryTabsEnum.closed]: 'waves.ClosedBet', 
    [HistoryTabsEnum.public]: 'waves.PublicBet', 
    [HistoryTabsEnum.leaderboard]: 'waves.Leaderboard', 
};

// ================================================================ 

const footerShowing = computed(()=>{
    return (
        type.value == HistoryTabsEnum.active 
        && props.fnCashOut
    );
});

const type = computed(()=>{
    const sResult = (
        // ↓ 窗口弹出方需要指定窗口标题 
        route?.query?.wavesType
        || HistoryTabsEnum.public
    );
    return sResult; 
});

const sDateFormet = computed(() => {
    if (locale.value == 'cn'){
        // 2024/08/21 14:10
        return 'YYYY/MM/DD HH:mm';
    }
    // 08/21/2024, 02:13 PM 
    return 'DD/MM/YYYY, hh:mm a';
});


// ↓ 仅在 active 合约使用 
const oActiveContractInfo = computed(()=>{
    if (props.history.state == oWavesContractStatus.active){
        return getActiveContractInfo(props.history);
    }
});

// ↓ 禁用提现按钮 
const disabledCashoutButton = computed(()=>{
    const his = props.history;
    const stateRealtime = oActiveContractInfo.value?.stateRealtime; 
    const bResult = (
        his.state == oWavesContractStatus.active
        && !!stateRealtime
        && stateRealtime != WavesContractStateAll.active 
    );
    return bResult;
});

// ↓ 特殊币标记 
const isSpecialPair = computed(()=>{
    const his = props.history; 
    const bResult = his.pair == oSpecialCoin?.pairName;
    return bResult; 
});

const sTitleI18nKey = computed(()=>{
    // ↓ 取得页签对应的名称 
    const sResult = oDialogTitles[type.value as any]; 
    return sResult; 
});

// ↓ 手续费金额显示值 
const sFeeAmount = computed(() => {
    const his = props.history; 
    const isPNL = his.feeType === oPnlFlat.pnl; // ←根据目前观察窗口中 pnl 类型标记后没有显示金额的数值 
    // ↓ 特殊币 isSpecialPair 无手续费 
    if (isPNL || isSpecialPair.value){
        return '';
    }
    let fNumber = 0; 
    if (his.feeType === oPnlFlat.flat){
        fNumber = his.flatFee;
    }
    if (!fNumber) return '';
    const sCurrency = (his.currency || '').toUpperCase(); 
    const iDecimalPlaces = (his.iDecimalPlaces || 2) + 1;
    const sResult = ` ${sCurrency} ${Number(fNumber.toFixed(iDecimalPlaces))}`; 
    return sResult;
});

const oColors = computed(()=>{
    const his = props.history; 
    const isActive = his.state == oWavesContractStatus.active; 
    const sGreen = oColorInfo.green.color;
    const sRed = oColorInfo.red.color;
    const oResult = {
        pnl: (()=>{
            if (!isActive){
                his.oPNLColor || console.log('oPNLColor missed', deepCopy(his));
                return his.oPNLColor?.color;
            }
            return (
                oFinalPnlAndRoi.value.pnl > 0 
                ? sGreen
                : sRed
            );
        })(),
        roi: (()=>{
            if (!isActive){
                his.oROIColor || console.log('oROIColor missed', deepCopy(his));
                return his.oROIColor?.color;
            }
            return (
                oFinalPnlAndRoi.value.roi >= 0 
                ? sGreen
                : sRed
            );
        })(),
        funding: (()=>{
            if (his.funding > 0){
                return sGreen;
            }else if (his.funding < 0){
                return sRed;
            }
            return ''; // 默认灰色
        })(),
    };
    // console.log('窗口颜色计算：', deepCopy(oResult)); 
    return oResult; 
});

// ↓ 返回止盈止损颜色值（四选一）
const oTriggerColor = computed(() => {
    const state = props.history.state;
    const isLoss = state == oWavesContractStatus.loss;
    const isProfit = state == oWavesContractStatus.profit;
    const oResult = {
        profitPrice: {},
        profitValue: {},
        lossPrice: {},
        lossValue: {},
    };
    if (!isProfit && !isLoss) {
        return oResult;
    }
    let sKey = '';
    let sColor = ''; 
    if (isProfit){
        sColor = oColorInfo.green.color;
        const TriggerProfit = props.history.selectedTriggerProfit; 
        sKey = {
            'price': 'profitPrice',
            'value': 'profitValue',
        }[TriggerProfit];
    }else if (isLoss){
        sColor = oColorInfo.red.color;
        const TriggerLoss = props.history.selectedTriggerLoss; 
        sKey = {
            'price': 'lossPrice',
            'value': 'lossValue',
        }[TriggerLoss];
    }
    oResult[sKey] = {
        color: sColor,
    };
    // console.log("颜色信息：", deepCopy(oResult)); 
    return oResult; 
});


// ↓ 返回特定数值信息 
const oFinalPnlAndRoi = computed(() => {
    const oDefault = {
        pnl: props.history.pnl,
        roi: props.history.roi || 0,
    }; 
    if (type.value === HistoryTabsEnum.active){
        return oActiveContractInfo.value || oDefault;
    }
    return oDefault; 
});

watch(
    ()=>props.modelValue,
    (bNewVal)=>{
        if (!bNewVal) return;
        console.log("窗口已经打开，数据 ↓\n", deepCopy(props.history)); 
    },
);


const handleUpdateModelValue = (bNewValue) => {
    emits('update:modelValue', !!bNewValue);
}
</script>


<style src="./style/WavesDetail.scss" scoped lang="scss"></style>


